<script>
import VideoCarousel from "./VideoCarousel.vue";
import VideoToggle from "./VideoToggle.vue";
export default {
  components: {
    VideoCarousel,
    VideoToggle,
  },
  data() {
    return {
      slidesComponent: "VideoCarousel",
      mediaQuery: null,
    };
  },
  props: {
    surface: {
      type: String,
      default: "light",
    },
    content: {
      required: true,
    },
  },

  mounted() {
    this.mediaQuery = window.matchMedia("(min-width: 1200px)");
    this.mediaQuery.addEventListener("change", this.handleMediaQueryChange);
    this.handleMediaQueryChange();
  },
  methods: {
    handleMediaQueryChange() {
      if (this.mediaQuery.matches) {
        this.slidesComponent = "VideoToggle";
      } else {
        this.slidesComponent = "VideoCarousel";
      }
    },
    pickComponent() {
      if (window.innerWidth < 991) {
        this.slidesComponent = "VideoCarousel";
      } else {
        this.slidesComponent = "VideoToggle";
      }
    },
    surfacePicker() {
      if (this.surface === "dark") {
        return "vw-dark-surface";
      } else if (this.surface === "darkest") {
        return "vw-darkest-surface";
      } else {
        return "";
      }
    },
  },
};
</script>
<template>
  <article class="slideshow">
    <AppSingleColumn :content="content.description" :index="2" />
    <component :is="slidesComponent" :slides="content.slides" />
  </article>
</template>

<style lang="scss" scoped>
@import "../styles/01-settings/breakpoints";
@import "../styles/01-settings/mq";
div {
  background-color: var(--background-color);
  color: var(--text-color);
}
.slideshow {
  --component-padding: 50px;
  margin-top: 0px;
  padding-bottom: var(--component-padding);
}
.slideshow {
  .vw-component {
    --component-padding: 30px;
  }
}
@include mq($from: sm, $until: lg) {
  .slideshow {
    --component-padding: 90px;
    padding-bottom: var(--component-padding);
    .vw-component {
      --component-padding: 50px;
    }
  }
}
@include mq($from: lg) {
  .slideshow {
    --component-padding: 125px;
    padding-bottom: var(--component-padding);
    .vw-component {
      --component-padding: 50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/AppSlideShow.vue